import React from "react";
import IconRight from "../../../Resources/svg/Icons/IconRight";
import IconInfoCircle from "../../../Resources/svg/Icons/IconInfoCircle";

const Terciary = ({handleSwitch}: any) => {
  return (
    <div className="terciary">
      <IconInfoCircle className="icon-info"/>
      <div className="terciary__content">
        <div className="terciary__title">Firma de forma manual</div>
        <div className="terciary__text">
          Si tu cliente ha tenido problemas con el proceso biométrico podrás
          activar el proceso manual. Ten en cuenta que si activas este proceso
          no podrás revertirlo.
        </div>
        <div className="terciary__actions" onClick={handleSwitch}>
          Activar proceso manual <IconRight />
        </div>
      </div>
    </div>
  );
};

export default Terciary;
